import { render, staticRenderFns } from "./lzys.vue?vue&type=template&id=795b6c42&scoped=true&"
import script from "./lzys.vue?vue&type=script&lang=js&"
export * from "./lzys.vue?vue&type=script&lang=js&"
import style0 from "./lzys.vue?vue&type=style&index=0&id=795b6c42&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795b6c42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('795b6c42')) {
      api.createRecord('795b6c42', component.options)
    } else {
      api.reload('795b6c42', component.options)
    }
    module.hot.accept("./lzys.vue?vue&type=template&id=795b6c42&scoped=true&", function () {
      api.rerender('795b6c42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lzys.vue"
export default component.exports